import React from 'react'
import Wprr from 'wprr'

export default class Footer extends Wprr.BaseObject {

    _construct(){
        super._construct();

       
    }

    _renderMainElement() {

        let copyright = "© " + (new Date()).getFullYear() + " Whiston Farm Storage";


        let mobileLayout = <div>
            <Wprr.FlexRow className="justify-center">
                <div>
                    <Wprr.Link href={Wprr.sourceReference("wprr/paths/home")} className="custom-styled-link">
                        <Wprr.Image src="logo.png" className="image background-contain footer-logo small" />
                    </Wprr.Link>
                </div>
            </Wprr.FlexRow>
            <div className="spacing micro" />
            <Wprr.layout.wordpress.Menu location="footer-menu_default">
                <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                    <div className="header-menu-link text-align-center">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                    
                </Wprr.Link>
                <div data-slot="spacing" className="spacing micro" />
            </Wprr.layout.wordpress.Menu>
            <div className="spacing small" />
            <Wprr.layout.wordpress.Menu location="footer-menu_legal">
                <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                    <div className="header-menu-link text-align-center">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                </Wprr.Link>
                <div data-slot="spacing" className="spacing micro" />
            </Wprr.layout.wordpress.Menu>
        </div>;
        

        let desktopLayout = <div>
            <Wprr.FlexRow className="small-item-spacing align-end" itemClasses="half,flex-no-resize,half">
                <div>
                    <Wprr.layout.wordpress.Menu location="footer-menu_default">
                        <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                            <div className="header-menu-link">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                        </Wprr.Link>
                        <Wprr.FlexRow data-slot="insertElements" className="small-item-spacing" />
                    </Wprr.layout.wordpress.Menu>
                    <div className="spacing micro" />
                </div>
                <div>
                    <Wprr.Link href={Wprr.sourceReference("wprr/paths/home")} className="custom-styled-link">
                        <Wprr.Image src="logo.png" className="image background-contain footer-logo small" />
                    </Wprr.Link>
                </div>
                <div>
                    <Wprr.FlexRow className="small-item-spacing" itemClasses="flex-resize,flex-no-resize">
                        <div />
                        <Wprr.layout.wordpress.Menu location="footer-menu_legal">
                            <Wprr.Link href={Wprr.sourceReference("item", "url")} className="custom-styled-link">
                                <div className="header-menu-link">{Wprr.text(Wprr.sourceReference("item", "label"))}</div>
                            </Wprr.Link>
                            <Wprr.FlexRow data-slot="insertElements" className="small-item-spacing" />
                        </Wprr.layout.wordpress.Menu>
                    </Wprr.FlexRow>
                    <div className="spacing micro" />
                </div>
            </Wprr.FlexRow>
        </div>;

        let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
        responsiveLayout.addResponsiveTemplate(desktopLayout, 600);


        return <footer>
            <div className="centered-site">
                {responsiveLayout.getReactElements()}
                <div className="spacing small" />
                <div className="horizontal-line footer-divider" />
                <div className="spacing small" />
                <div className="footer-address text-align-center">
                    Whiston Farm Storage,<br />
                    Whiston Farm<br />
                    Ford, <br />
                    Shrewsbury<br />
                    Shropshire, SY5 9NG
                </div>
                <div className="spacing small" />
                <div className="footer-copyright text-align-center">
                    {Wprr.text(copyright)}
                </div>
                <div className="spacing small" />
                <div>
                    <Wprr.FlexRow className="small-item-spacing justify-center" >
                        <div className="social-media-footer-link">

                        </div>
                        <div className="social-media-footer-link">

                        </div>
                        <div className="social-media-footer-link">

                        </div>
                        <div className="social-media-footer-link">

                        </div>
                    </Wprr.FlexRow>
                </div>
                <div className="spacing double" />
                <div className="text-align-center built-by-notice-link">
                    <a href="https://developedbyme.com" className="custom-styled-link">Built by Developedbyme</a>
                </div>
                <div className="spacing standard" />
            </div>
        </footer>;
    }
}
